<script>
  import Title from "./Title.svelte";
  import { redirect } from "../pager";
  function toggleFilter() {
    if (document.getElementById("filterCont").style.display == "none") {
      document.getElementById("filterCont").style.display = "block";
    } else if (document.getElementById("filterCont").style.display == "block") {
      document.getElementById("filterCont").style.display = "none";
    } else {
      document.getElementById("filterCont").style.display = "block";
    }
  }

  //liblary
  import axios from "axios";
  import { session } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  const removeDuplicate = function (arr) {
    return arr.filter(function (item, index) {
      return arr.indexOf(item) === index;
    });
  };

  export let category;
  export let q;
  export let domain;
  $: listcategory = [];
  $: parent = 0;
  function loadCat(cat = false) {
    let area="";
  if (localStorage["area"]) {
    area = localStorage["area"];
  }
    if (cat) {
      category = cat;
    }
    axios
      .get(settings.url + "/warga/categories", {
        params: {
          authorization: settings.token,
          category: category,
          q: q,
          domain: domain,
          market: true,
          area: area,
        },
      })
      .then(function (response) {
        listcategory = response.data.data;
      });
  }
  if (settings) {
    loadCat();
    setTimeout(() => {
      sortOut();
    }, 1000);
  }
  let nav_domain = domain;
  if (domain) {
    nav_domain = domain + "/";
  }

  import { activeRoute } from "../pager/Router.svelte"; 

  let query = "";
  function handleSearch() {
    query = query.replace(/\s+/g, "+");
    var url = $activeRoute.path.split("/");
    if (query != "") {
      if (url[1] == "cari") {
        redirect("/belanja/" + nav_domain + "q/" + query);
      } else {
        redirect("/cari/" + nav_domain + "q/" + query);
      }
    } else {
      redirect("/belanja/" + nav_domain);
    }
  }

  function sortOut() {
    var classname = document.getElementsByClassName("itemCat");
    var divs = [];
    for (var i = 0; i < classname.length; ++i) {
      divs.push(classname[i]);
    }
    divs.sort(function (a, b) {
      return a.dataset.val.localeCompare(b.dataset.val);
    });

    document.getElementById("listFilterCat").innerHTML = "";
    divs.forEach(function (el) {
      document.getElementById("listFilterCat").appendChild(el);
    });
    
  if ($activeRoute.params.category) { 
      setTimeout(() => { 
        Array.from(document.getElementsByClassName("parent-" + $activeRoute.params.category)).forEach((el) => { 
            el.classList.add("font-bold");
          }); 
      }, 500); 

    } 
  }

  function parentChange(val, index = 2) {
    Array.from(document.getElementsByClassName("parent")).forEach((el) => {
      el.classList.remove("font-bold");
    });
    console.log("val : " + val);
    if (val.length > 3) {
      if (index == 1) {
        setTimeout(() => {
          Array.from(
            document.getElementsByClassName("parent-" + val.substring(0, 4))
          ).forEach((el) => {
            el.classList.add("font-bold");
          });
        }, 500);
      }
    }
    let value = val.substring(0, 2);
    if (value > 9 && value < 31) {
      parent = val.substring(0, 2);
    }
    if (value < 10) {
      parent = val.substring(0, 1);
    }
    console.log(document.getElementById("parent-" + parent));
    document.getElementById("parent-" + parent).classList.add("font-bold");
    if (index == 0) {
      setTimeout(() => {
        Array.from(document.getElementsByClassName("parent-" + parent)).forEach(
          (el) => {
            el.classList.add("font-bold");
          }
        );
      }, 500);
    }
  }

  function categoryFind() {
    var input, filter, card, h5, a, i;
    input = document.getElementById("searchCatfilter");
    filter = input.value.toUpperCase();
    card = document.getElementsByClassName("itemCat");
    for (i = 0; i < card.length; i++) {
      a = card[i].getElementsByTagName("a")[0];
      if (a.innerHTML.toUpperCase().indexOf(filter) > -1) {
        card[i].style.display = "";
      } else {
        card[i].style.display = "none";
      }
    }
  }
 

</script>

<aside
  id="filterCont"
  class="fixed inset-0 z-30 hidden w-full h-full -mt-10 overflow-y-auto bg-white border-t shadow-lg lg:block lg:sticky md:fixed lg:rounded-lg lg:w-3/12 lg:px-3 lg:mx-3 lg:m-0 md:-mt-10 lg:z-0 overscroll-contain"
  style="top: 90px;">
  <div class="sticky-sidebar">
    <div class="sticky-sidebar-inner lg:pb-24 lg:mb-5 lg:mt-5">
      <div
        class="sticky top-0 z-10 py-1 bg-white lg:py-0">
        <div class="absolute top-0 right-0 block mt-4 mr-2 lg:hidden md:block">
          <button
            aria-label="Toggle Filter Market"
            class="p-2 text-xl border border-gray-300 rounded-lg"
            on:click={toggleFilter}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              class="w-4 h-4">
              <path
                d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414
                1.414L10 11.414l7.071 7.071 1.414-1.414L11.414
                10l7.071-7.071-1.414-1.414L10 8.586z" />
            </svg>
          </button>
        </div>

        <Title subtitle="Persempit Hasil" title="Filter" />
      </div>
      
      <form
        action="/shop/search"
        class="relative flex items-stretch justify-center order-last w-full px-2 py-2 mt-2 mb-5 rounded-lg shadow-md pointer-events-none search lg:order-none lg:hidden lg:shadow-none"
        on:submit|preventDefault={handleSearch}>
        <input
          id="searchfilter"
          class="w-full p-3 py-2 pr-12 text-xs font-light bg-white border border-gray-200 rounded shadow outline-none pointer-events-auto md:focus:border-blue-600"
          type="text"
          name="q"
          autocomplete="off"
          bind:value={query}
          placeholder="Cari nama produk..." />
          {#if query.length>0}
        <label for="searchfilter" on:click={()=>query=""}
          class="absolute top-0 bottom-0 right-0 flex items-center justify-center flex-grow h-full pr-4 my-auto mr-10 pointer-events-auto clear">
          <img src="./assets/svg/close.svg" alt="clear">
        </label> 
        {:else}
        <label for="searchfilter" on:click={()=>query=""}
          class="absolute top-0 bottom-0 right-0 flex items-center justify-center flex-grow invisible h-full pr-4 my-auto mr-10 pointer-events-auto clear">
          <img src="./assets/svg/close.svg" alt="clear">
        </label> 
        {/if} 
         
        <button
          aria-label="Search"
          type="submit"
          class="absolute top-0 bottom-0 right-0 flex items-center justify-center flex-grow h-auto px-3 my-2 border-l border-gray-400 pointer-events-auto md:border-l-0 focus:bg-gray-500 focus:outline-none">
          <img src="./assets/svg/search.svg" alt="search" />
        </button>
      </form>
      <div class="lg:hidden">
        <Title subtitle="Kategori Produk" title="Kategori" />
      </div>
      <div
        class="sticky top-0 z-10 flex items-stretch justify-center order-last w-full px-2 py-2 mt-4 mb-5 bg-white rounded-lg shadow pointer-events-none search lg:order-none lg:shadow-none"
        style="
        top: 85px;
    ">
        <input
          on:keyup={() => categoryFind()}
          id="searchCatfilter"
          class="w-full p-3 py-2 text-xs font-light bg-white border border-gray-200 rounded shadow outline-none pointer-events-auto md:focus:border-blue-600"
          type="text"
          name="qcat"
          autocomplete="off"
          placeholder="Cari nama Kategori..." />
        <label
          for="searchCatfilter" on:click={()=>document.getElementById("searchCatfilter").value =""}
          class="absolute top-0 bottom-0 right-0 flex items-center justify-center flex-grow h-full my-auto mr-2 pointer-events-auto clear">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="hidden w-2 h-2 m-1 lg:w-3 lg:h-3 lg:inline-block"><path d="M12 12l8-8V0H0v4l8 8v8l4-4v-4z"></path></svg>
        </label>
      </div>

      <ul
        id="listFilterCat"
        class="w-full mb-16 text-sm lg:block lg:mb-8"
        style="
        max-height: 80vh;
        overflow-x: auto;
    ">
        {#each removeDuplicate(listcategory) as lc}
          {#if lc.value == 0}
            {#if q}
              <li data-val="0" class="chevron-right itemCat">
                <a
                  on:click={() => loadCat(lc.alias)}
                  class="px-3 py-2 block
                          hover:bg-gray-100 transition {lc.active}"
                  href="belanja/{nav_domain}q/{q}">
                  {lc.title}
                </a>
              </li>
            {:else}
              <li data-val="0" class="chevron-right itemCat">
                <a
                  on:click={() => loadCat(lc.alias)}
                  class="px-3 py-2 block
                          hover:bg-gray-100 transition {lc.active}"
                  href="belanja/{nav_domain}">
                  {lc.title}
                </a>
              </li>
            {/if}
          {:else if q}
            {#if lc.parent}
              <li data-val={lc.parent.value} class="chevron-right itemCat">
                <a
                  id="parent-{lc.parent.value}"
                  on:click={() => parentChange(lc.value, 0)}
                  on:click={() => loadCat(lc.parent.alias)}
                  class="parent parent-{lc.parent.alias} px-3 py-2 block
                          hover:bg-gray-100 transition"
                  href="belanja/{nav_domain}c/{lc.parent.alias}/q/{q}">
                  {lc.parent.title}
                  <span class="hidden">{lc.parent.title}</span>
                </a>
              </li>
            {/if}

            <li data-val={lc.value} class="chevron-right itemCat">
              <a
                on:click={() => loadCat(lc.alias)}
                on:click={() => parentChange(lc.value, 1)}
                class="parent parent-{lc.value.substring(0, 2)}  parent-{lc.alias} parent-{lc.value} parent-{lc.parent_identify.alias}  px-3 py-2 block
                            hover:bg-gray-100 transition {lc.active}"
                href="belanja/{nav_domain}c/{lc.alias}/q/{q}">
                -
                {lc.title}<span class="hidden">{lc.parent.title}
                  {lc.title}</span>
              </a>
            </li>
            {#each lc.sub as ls}
              <li data-val={ls.value} class="chevron-right itemCat">
                <a
                  on:click={() => loadCat(ls.alias)}
                  on:click={() => parentChange(lc.value)}
                  class="parent parent-{lc.value.substring(0, 2)}  parent-{lc.value.substring(0, 4)}  parent-{lc.alias} parent-{lc.parent_identify.alias} px-3 py-2 block
                              hover:bg-gray-100 transition {ls.active}"
                  href="belanja/{nav_domain}c/{ls.alias}/q/{q}">
                  --
                  {ls.title}<span class="hidden">{lc.parent.title}
                    {lc.title}
                    {ls.title}</span>
                </a>
              </li>
            {/each}
          {:else}
            {#if lc.parent}
              <li data-val={lc.parent.value} class="chevron-right itemCat">
                <a
                  data-find={lc.parent.title}
                  id="parent-{lc.parent.value}"
                  on:click={() => parentChange(lc.value, 0)}
                  on:click={() => loadCat(lc.parent.alias)}
                  class="parent  parent-{lc.parent.alias} px-3 py-2 block
                        hover:bg-gray-100 transition"
                  href="belanja/{nav_domain}c/{lc.parent.alias}">
                  {lc.parent.title}
                  <span class="hidden">{lc.parent.title}</span>
                </a>
              </li>
            {/if}
            <li data-val={lc.value} class="chevron-right itemCat">
              <a
                data-find="{lc.parent.title} {lc.title}"
                on:click={() => loadCat(lc.alias)}
                on:click={() => parentChange(lc.value, 1)}
                class="parent parent-{lc.value.substring(0, 2)} parent-{lc.value}  parent-{lc.alias} parent-{lc.parent_identify.alias} px-3 py-2 block
                          hover:bg-gray-100 transition {lc.active}"
                href="belanja/{nav_domain}c/{lc.alias}">
                -
                {lc.title}<span class="hidden">{lc.parent.title}
                  {lc.title}</span>
              </a>
            </li>
            {#each lc.sub as ls}
              <li data-val={ls.value} class="chevron-right itemCat">
                <a
                  data-find="{lc.parent.title} {lc.title} {ls.title}"
                  on:click={() => loadCat(ls.alias)}
                  on:click={() => parentChange(lc.value)}
                  class="parent parent-{lc.value.substring(0, 2)} parent-{lc.value.substring(0, 4)}  parent-{lc.parent_identify.alias} px-3 py-2 block
                            hover:bg-gray-100 transition {ls.active}"
                  href="belanja/{nav_domain}c/{ls.alias}">
                  --
                  {ls.title}<span class="hidden">{lc.parent.title}
                    {lc.title}
                    {ls.title}</span>
                </a>
              </li>
            {/each}
          {/if}
        {/each}
      </ul>
    </div>
  </div>
</aside>
